import { render, staticRenderFns } from "./AnnotationDetails.vue?vue&type=template&id=09ec6715&scoped=true"
import script from "./AnnotationDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetails.vue?vue&type=style&index=0&id=09ec6715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec6715",
  null
  
)

export default component.exports